import {writable} from 'svelte/store';
import {fetchWithAuth} from '$lib/utils/http/httpUtil';

// null until loaded, so guards can wait instead of acting on a false default.
export const mailOcrEnabled = writable<boolean | null>(null);

export async function loadSettings(): Promise<void> {
    try {
        const res = await fetchWithAuth('/api/settings');
        if (res.ok) {
            const data = await res.json();
            mailOcrEnabled.set(data.mailOcrEnabled === true);
            return;
        }
    } catch {
        // fall through — treat sections as disabled
    }
    mailOcrEnabled.set(false);
}
